import React, { useState, useEffect } from 'react';
//import PropTypes from 'prop-types';
import {
  Label,
  InputGroupText,
  InputGroup,
  Button,
  Modal,
} from 'reactstrap';
import { DatetimePicker } from '../../../commons/controls';
import Services from '../services';
import _ from 'lodash';
import moment from 'moment';
import RFField from '../../../components/Form/RFField';
import RFForm from '../../../components/Form/RFForm';
import TimeFormatter from '../../../commons/TimeFormatter';
import ProgressButton from '../../../commons/ProgressButton';

const ROW_STYLE = {marginBottom: '15px'};

const PartnerForm = props => {

  const {
    modositas,
    aktivalas,
    formKartyaTipus,
    formHelyszin,
    onRowSelect,
    setPartnerResponse,
    toggleShowTulajdonosForm,
  } = props;

  const [formVezeteknev, setVezeteknev] = useState('');
  const [formKeresztnev, setKeresztnev] = useState('');
  const [formSzuletesnap, setSzuletesnap] = useState(null);
  const [formEmail, setEmail] = useState('');
  const [formTelefonszam, setTelefonszam] = useState('');
  const [loading, setLoading] = useState(false);

  const savePartner = () => {
    let submitObj = {};
    setLoading(true);

    submitObj.kartyaTipusId = formKartyaTipus && formKartyaTipus.id;
    submitObj.helyszinId = formHelyszin && formHelyszin.id;
    submitObj.vezeteknev = formVezeteknev;
    submitObj.keresztnev = formKeresztnev;
    submitObj.szuletesnap = formSzuletesnap ? TimeFormatter.formatDate(formSzuletesnap) : null;
    submitObj.email = formEmail;
    submitObj.telefonszam = formTelefonszam;

    Services.insertPartnerBase(submitObj, (err, res) => {
      setLoading(false);
      if (!err) {
        toggleShowTulajdonosForm(false);
        onRowSelect({id: res[0].ptId}, true);
        setPartnerResponse(res[0]);
        hozzajarulasKuldes(res[0]);
      }
    });
  }

  const hozzajarulasKuldes = (hozzajarulasData) => {
    Services.setHozzajarul(hozzajarulasData.pId, true, hozzajarulasData.hozzajarulasok, (err) => {
      if (!err) {
       //globals.addSuccess('Partner felvéve!');
       toggleShowTulajdonosForm(false);
      }
    });
  }

  const isVisibleTulajdonos = (input) => {
    return formKartyaTipus && formKartyaTipus[input] && formKartyaTipus[input].name !== 'NEM_JELENIK';
  }

  const isRequiredTulajdonos = (input) => {
    return formKartyaTipus && formKartyaTipus[input].name === 'KOTELEZO';
  }

  const isDisabledTulajdonos = () => {
    return modositas && !aktivalas;
  }

  const renderForm = () => {
    return (
      <React.Fragment>
        <div className="row" style={ROW_STYLE}>
          <div className="col-md-6">
            <RFField
              label="Vezetéknév: "
              name={"formVezeteknev"}
              value={formVezeteknev}
              onChange={(e,v) => setVezeteknev(v)}
              required
              />
          </div>
          <div className="col-md-6">
            <RFField
              label="Keresztnév: "
              name={"formKeresztnev"}
              value={formKeresztnev}
              onChange={(e,v) => setKeresztnev(v)}
              required
            />
          </div>
          {isVisibleTulajdonos("szuletesnap") && (
            <div className="col-md-6">
              <DatetimePicker
                label={'Születésnap: '}
                id={"formSzuletesnap"}
                name={"formSzuletesnap"}
                containerClassName="organw-date-time"
                time={false}
                // format="YYYY-MM-DD"
                messages={{ dateButton: "dátum", timeButton: "idő" }}
                onChange={(e,v) => setSzuletesnap(v)}
                value={formSzuletesnap && new Date(formSzuletesnap)}
                //disabled={isDisabledTulajdonos()}
                required={isRequiredTulajdonos("szuletesnap")}
              />
            </div>
          )}
        </div>
        <div className="row">
          <div className="col-md-12" style={{paddingRight: '2px'}}>
            <h5>Elérhetőség</h5>
          </div>
        </div>
        <div className="row" style={ROW_STYLE}>
          {isVisibleTulajdonos("telefon") && (
            <div className="col-md-6">
              <RFField
                label="Telefonszám: "
                name={"formTelefonszam"}
                value={formTelefonszam}
                onChange={e => setTelefonszam(e.target.value)}
                prepend="+36"
                //disabled={isDisabledTulajdonos()}
                required={isRequiredTulajdonos("telefon")}
              />
            </div>
          )}
          {isVisibleTulajdonos("email") && (
            <div className="col-md-6">
              <RFField
                label="Email: "
                name={"formEmail"}
                value={formEmail}
                onChange={e => setEmail(e.target.value)}
                //disabled={isDisabledTulajdonos()}
                required={isRequiredTulajdonos("email")}
              />
            </div>
          )}
          </div>
      </React.Fragment>
    );
  }

  return (
    <Modal isOpen backdrop="static">
      <RFForm
        modal
        onSubmit={savePartner}
        title="Új partner hozzáadása"
        footer={
          <>
            <ProgressButton type="submit" color="primary" loading={loading}>Kiválaszt</ProgressButton>
            <Button type="button" color="secondary" onClick={() => toggleShowTulajdonosForm(false)}>Mégsem</Button>
          </>
        }
      >
        <div className="row">
          <div className="col-md-12">
            {renderForm()}
          </div>
        </div>
      </RFForm>
    </Modal>
  );
}

export default PartnerForm;